import React from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import request from "../../utils/http";
import { useState } from "react";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { AiFillDelete } from "react-icons/ai";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const UserHome = (props: any) => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();
	const [files, setFiles] = useState([] as any);

	const loadFiles = async () => {
		let result = await request("GET", `/api/admin/asset-file/all`, null);
		if (result.success && result.data) {
			setFiles(result.data.files);
		}
	};

	useEffect(() => {
		loadFiles();
	}, [urlParams]);

	return (
		<Container>
			<ActionHeader>
				<h1>Files</h1>
				<Button
					onClick={() => {
						navigate({
							pathname: `/file/create`,
						});
					}}
				>
					Create
				</Button>
			</ActionHeader>
			<hr />
			<StyledTable role="grid" $gridTemplateColumns={"1fr 2fr 1fr	1fr 1.5fr 0.5fr"}>
				<StyledTableRow role="row">
					<StyledHeadCell>Name</StyledHeadCell>
					<StyledHeadCell>Notes</StyledHeadCell>
					<StyledHeadCell>Type</StyledHeadCell>
					<StyledHeadCell>Department</StyledHeadCell>
					<StyledHeadCell>File</StyledHeadCell>
					<StyledHeadCell>Actions</StyledHeadCell>
				</StyledTableRow>

				{files &&
					files.map((file: any, i: number) => {
						const striped = i % 2 === 0;

						return (
							<StyledTableRow role="row">
								<StyledBodyCell $striped={striped}>{file.name}</StyledBodyCell>
								<StyledBodyCell $striped={striped}>{file.notes}</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{file.assetFileType === "PositionDescription"
										? "Job Description"
										: file.assetFileType}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>{file.assetFileDepartmentType}</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									<a href={file.fileLink} target="_blank">
										Download
									</a>
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									<Button
										kind="tertiary"
										onClick={async () => {
											await request("POST", `/api/admin/asset-file/delete`, {
												assetFileId: file.id,
											});
											loadFiles();
										}}
									>
										<AiFillDelete />
									</Button>
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};
export default UserHome;
